import { makeStyles, createStyles, Theme } from '@material-ui/core';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        fontSize: 13,
      },
      alignStart: {
        justifyContent: 'flex-start',
      },
      icon: {
        color: sicrediColor.primarySicrediDark,
        marginRight: 3,
        fontSize: '1.5em',
      },
      text: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 300,
        fontSize: 12,
        color: sicrediColor.secondarySicrediDarker,
        '&:first-of-type': {
          marginRight: theme.spacing(2.5),
        }
      },
    }),
  { name: 'AssembleiaDateTime' }
);
